import { createContext, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import api from "../lib/api";

const AuthCtx = createContext(null);

export function homeForRole(role) {
  return role === "admin" ? "/admin" : role === "supplier" ? "/supplier" : "/portal";
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);
  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data.user);
    return data.user;
  };
  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setUser(data.user);
    return data.user;
  };
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };
  return (
    <AuthCtx.Provider value={{ user, setUser, login, register, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  return useContext(AuthCtx);
}

export function ProtectedRoute({ role, children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen bg-ink flex items-center justify-center" data-testid="auth-loading">
        <div className="w-8 h-8 border-2 border-gold border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to={homeForRole(user.role)} replace />;
  return children;
}
